<template>
  <div class="content content4">
      <div class="tab clearfix">
          <span class="title fl">#<span>投资案例</span></span>
          <ul class="fr">
              <li v-for="(item, index) in tabList" :key="index" @click="clickEvent(index)">
                  {{item}}
                  <span class="active" v-show="isActive == index"></span>
                </li>
          </ul>
      </div>
      <div class="swiper">
        <swiper :options="swiperOption">
          <swiper-slide v-for="(slide,index) in investList[isActive].slideInfo" :key="index">
            <img :src="slide.imgUrl" alt="" >
            <div class="info">
              <p :class="['name', !slide.introduce ? 'mt_60' : '' ]">{{slide.name}}</p>
              <p class="introduce" v-if="slide.introduce">{{slide.introduce}}</p>
              <p class="code" v-if="slide.stockRightCode">股权代码：<span class="bold-font">{{slide.stockRightCode}}</span></p>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
  </div>
</template>

<script>
// 大消费
import investConsume1 from './invest-consume1.jpg'
import investConsume2 from './invest-consume2.jpg'
import investConsume3 from './invest-consume3.jpg'
import investConsume4 from './invest-consume4.jpg'
import investConsume5 from './invest-consume5.jpg'
import investConsume6 from './invest-consume6.jpg'
import investConsume7 from './invest-consume7.jpg'
// import investConsume8 from './invest-consume8.jpg'
import investConsume9 from './invest-consume9.jpg'
import investConsume10 from './invest-consume10.jpg'
import investConsume11 from './invest-consume11.jpg'
import investConsume12 from './invest-consume12.jpg'
import investConsume13 from './invest-consume13.jpg'
import investConsume14 from './invest-consume14.jpg'
import investConsume15 from './invest-consume15.jpg'
import investConsume16 from './invest-consume16.jpg'
import investConsume17 from './invest-consume17.jpg'
import investConsume18 from './invest-consume18.jpg'
// 大健康
import investHealth1 from './invest-health1.jpg'
import investHealth2 from './invest-health2.jpg'
import investHealth3 from './invest-health3.jpg'
import investHealth4 from './invest-consume16.jpg'
import investHealth5 from './invest-health5.jpg'
import investHealth6 from './invest-health6.jpg'
import investHealth7 from './invest-health7.jpg'
// 高端制造
import investMake1 from './invest-make1.jpg'
import investMake2 from './invest-make2.jpg'
import investMake3 from './invest-make3.jpg'
import investMake4 from './invest-make4.jpg'
import investMake5 from './invest-make5.jpg'
import investMake6 from './invest-make6.jpg'
// TMT
import investTMT1 from './invest-TMT1.jpg'
import investTMT2 from './invest-TMT2.jpg'
import investTMT3 from './invest-TMT3.jpg'
import investTMT4 from './invest-TMT4.jpg'
import investTMT5 from './invest-TMT5.jpg'
import investTMT6 from './invest-TMT6.jpg'
import investTMT7 from './invest-TMT7.jpg'
import investTMT8 from './invest-TMT8.jpg'
// 环保
import investEnvir1 from './invest-envir1.jpg'
import investEnvir2 from './invest-envir2.jpg'
import investEnvir3 from './invest-envir3.jpg'

export default {
  data () {
    return {
      swiperOption: {
        slidesPerView: 3,
        slidesPerColumn: 2,
        spaceBetween: 5,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          bulletClass: 'my-bullet',
          bulletActiveClass: 'my-bullet-active'
        }
      },
      isActive: 0,
      tabList: ['大消费', '大健康', '高端制造', 'TMT', '环保'],
      investList: [
        {
          id: 0,
          slideInfo: [
            {
              imgUrl: investConsume17,
              name: '玛伊娅服饰',
              introduce: 'Maia Active，专为亚洲女生打造的运动品牌。其创始人兼设计总监欧逸柔获2020年度福布斯20位商界潜力女性。天猫大型活动期间，是唯一跻身运动服饰类目销售额TOP 10的初创品牌。并在同年11月获得近亿元B轮融资。'
            },
            {
              imgUrl: investConsume18,
              name: '纽西之谜',
              introduce: '纽西之谜，源自新西兰的护肤品牌，2000年成立，2014年正式登陆中国。2020年度天猫第一个实现月销百万笔超级大爆品的品牌，两大爆款产品助其登顶天猫美妆榜首。同年获两轮共4.5亿人民币融资，估值达5亿美金。'
            },
            {
              imgUrl: investConsume1,
              name: '铂涛集团',
              introduce: '从出行与休闲生活体验和价值诉求出发，涵盖酒店、公寓、咖啡连锁、艺术品公益平台等，旗下拥有近20个品牌，覆盖全国300多个城市。'
            },
            {
              imgUrl: investConsume2,
              name: '东方时尚',
              introduce: '东方时尚驾驶学校股份有限公司主营业务是驾驶员培训。总公司坐落于北京市大兴区，占地面积3000余亩，是目前国内规模最大、最专业、最具标准化和规模化的机动车驾驶培训机构。',
              stockRightCode: '603377'
            },
            {
              imgUrl: investConsume3,
              name: '红旗连锁',
              introduce: '成都红旗连锁有限公司已发展成为中国西部最具规模的以连锁经营、物流配送、电子商务为一体的商业连锁企业，是中国A股市场首家便利连锁超市上市企业。',
              stockRightCode: '002697'
            },
            {
              imgUrl: investConsume4,
              name: '莱凡网络',
              introduce: '旗下品牌Miss Candy，专注于健康美甲产品的研发，开创了“健康指彩”新品类，目前美誉度、知名度、销售额等均位列国内各品牌前茅。'
            },
            {
              imgUrl: investConsume5,
              name: '明通四季',
              introduce: '旗下品牌音米眼镜INMIX是深受年轻消费者欢迎的新一代时尚眼镜品牌。超过国内外众多眼镜品牌稳居线上销量第一，且保持着每年100%以上高速增长。'
            },
            {
              imgUrl: investConsume6,
              name: '丽家宝贝',
              introduce: '丽家宝贝建立起了中国目前最大、最先进的专业化育婴产品零售通路。集产品目录销售、连锁专卖店、网上购物、综合育儿服务为一体的新型服务模式的建立，使丽家宝贝成为中国育婴行业中发展最快的领先企业。'
            },
            {
              imgUrl: investConsume7,
              name: '洛克公园',
              introduce: '洛克公园运营团队从场地最高效的利用和最舒适的运动体验出发，开始运用新的建造理念，将嘻哈型篮球场转向更炫酷的篮球馆。'
            },
            //   {
            //       imgUrl: investConsume8,
            //       name: '年富供应链',
            //       introduce: '深圳市年富供应链有限公司作为国内领先的一体化供应链集成服务商，全国海关AEO高级认证企业（原全国海关AA类企业）、出入境检验检疫信用管理AA级企业、深圳市百强企业及中国民营500强企业。'
            //   },
            {
              imgUrl: investConsume9,
              name: '升达林业',
              introduce: '四川升达林业产业股份有限公司以清洁能源为公司主营业务，积极向清洁能源转型，快速推进LNG工厂、LNG加气站和城镇燃气等项目建设。',
              stockRightCode: '002259'
            },
            {
              imgUrl: investConsume10,
              name: '圣农发展',
              introduce: '福建圣农发展股份有限公司专注于白羽鸡生产三十多年，是国内同行业现代化程度最高、品质最好、规模最大的集饲料加工、祖代与父母代种鸡养殖、种蛋孵化、肉鸡饲养、肉鸡屠宰加工为一体的联合型企业。',
              stockRightCode: '002299'
            },
            {
              imgUrl: investConsume11,
              name: '双汇集团',
              introduce: '双汇集团是以肉类加工为主的大型食品集团，在全国18个省市建设了加工基地，集团旗下子公司有：肉制品加工、生物工程、化工包装、双汇物流、双汇养殖、双汇药业、双汇软件等，总资产约200多亿元，员工65000人，是中国最大的肉类加工基地。',
              stockRightCode: '000895'
            },
            {
              imgUrl: investConsume12,
              name: '望尘科技',
              introduce: '望尘科技（GALA SPORTS）是一家超酷的体育游戏和科技公司。核心成员来自梦工厂、微软、腾讯等，从AI引擎到三维重构，不仅是体育游戏，在基础技术研发上倾注了大量的心血和努力，为的是建立一整套让所有人都尖叫的赛事呈现系统。'
            },
            {
              imgUrl: investConsume13,
              name: '微格互动',
              introduce: '北京微格互动科技有限公司专注于车联网、大数据、车载智能硬件的开发与生产。主要产品有AutoBot Pro 、 AutoBot mini、AutoBot软件，以及AutoBot车车智能金刚支架和魔棒车充。'
            },
            {
              imgUrl: investConsume14,
              name: '永裕竹业',
              introduce: '公司总部位于“中国竹乡”——浙江省安吉县竹产业科技园区，是一家专业研发、生产与销售竹制品的现代化企业。'
            },
            {
              imgUrl: investConsume15,
              name: '优萃生物',
              introduce: '优萃公司致力于生物细胞医学，干细胞技术、基因技术、蛋白质与多肽技术、再生医学技术的研发，分别应用于皮肤的修复和保健、应用于健肤美肤、应用于美容化妆品、应用于高端生物抗衰老等领域。'
            },
            {
              imgUrl: investConsume16,
              name: '天草生物',
              introduce: '天草生物专注于天然植物活性成分的研发、生产与销售。作为国家级高新技术企业，天草先后承担了多项国家农业部星火计划项目，并与浙江大学建立了院士工作站，专注于天然植物成分的分离研究技术。'
            }
          ]
        },
        {
          id: 1,
          slideInfo: [
            {
              imgUrl: investHealth5,
              name: '来恩生物医药',
              introduce: ''
            },
            {
              imgUrl: investHealth6,
              name: '星德汉生物医疗',
              introduce: ''
            },
            {
              imgUrl: investHealth7,
              name: '百吉生物集团',
              introduce: ''
            },
            {
              imgUrl: investHealth1,
              name: '莱美药业',
              introduce: '重庆莱美药业股份有限公司创立于1999年，是一家集科研、生产、销售于一体的高新技术医药企业。',
              stockRightCode: '300006'
            },
            {
              imgUrl: investHealth2,
              name: '美康生物',
              introduce: '美康生物是一家专业从事医学诊断产品研发、生产、销售及服务的国家高新技术企业，全国卫生产业企业先进单位。公司参与行业标准制定8项，高等医学院教材编写项目2项 ，标准物质合作定值20余项。',
              stockRightCode: '300439'
            },
            {
              imgUrl: investHealth3,
              name: '宁远科技',
              introduce: '深圳宁远科技已成为医疗健联网运营、医疗行业软件开发领域的领跑者，依托先进的互联网及移动互联网技术，宁远科技致力于为中国医疗机构提供最好的医疗健康信息化解决方案，为中国人民提供优质、高效、便捷的医疗健康信息服务！'
            },
            {
              imgUrl: investHealth4,
              name: '天草生物',
              introduce: '天草生物专注于天然植物活性成分的研发、生产与销售。作为国家级高新技术企业，天草先后承担了多项国家农业部星火计划项目，并与浙江大学建立了院士工作站，专注于天然植物成分的分离研究技术。'
            }
          ]
        },
        {
          id: 2,
          slideInfo: [
            {
              imgUrl: investMake1,
              name: '达威股份',
              introduce: '四川达威科技股份有限公司是一家从事皮革化学品的研发、生产和销售的高新技术企业。',
              stockRightCode: '300535'
            },
            {
              imgUrl: investMake2,
              name: '国腾电子',
              introduce: '国腾集团一家以电子信息产业集群为基础，打造在高新科技领域具有核心竞争力的民族企业。先后研制出中国第一台IC卡公用付费电话机、中国第二代身份证读写设备，并承担了国家“863”、“973”、“核高基”等重大科研项目，参与了国家级重点项目“北斗一号工程”，是国家909芯片设计单位之一。',
              stockRightCode: '300101'
            },
            {
              imgUrl: investMake3,
              name: '华力兴',
              introduce: '深圳华力兴新材料股份有限公司是一家专业从事高端改性工程塑料研发、生产、销售和服务的“国家高新技术企业”。专注于智能移动终端、智能家居、智慧医疗、新能源汽车等应用领域，为行业客户提供高品质改性工程塑料，在各主要市场占有领先地位。'
            },
            {
              imgUrl: investMake4,
              name: '天奥电子',
              introduce: '成都天奥电子股份有限公司拥有国家认定企业技术中心，是高新技术企业，主要从事时间频率、北斗卫星应用产品的研发、生产、销售和服务。参加了载人航天、探月工程、北斗卫星导航系统等国家重大工程。'
            },
            {
              imgUrl: investMake5,
              name: '中航三鑫',
              introduce: '中航三鑫股份有限公司是国家高新技术企业和深圳市高新技术企业。形成了特玻幕墙、光伏两大产业链，拥有国家级特种玻璃重点实验室，承担了多个国家重点科技计划研发以及重大项目、重点工程、援外工程的建设。',
              stockRightCode: '002163'
            },
            {
              imgUrl: investMake6,
              name: '中泰模具',
              introduce: '东莞市中泰模具股份有限公司专业从事汽车冲压模具设计及生产的民营公司，近几年迅速向周边配套产业延伸发展。公司重视技术创新，目前拥有27个实有新型专利，1个发明专利，并参与起草GBT 33217-2016《冲压件毛刺高度》国家标准。'
            }
          ]
        },
        {
          id: 3,
          slideInfo: [
            {
              imgUrl: investTMT1,
              name: '丝路视觉',
              introduce: '丝路数字视觉作为全国性的专业数字视觉综合服务供应商，专注于CG应用领域，以创意为核心、市场需求为导向，主要利用计算机图形图像技术进行视觉设计和创作。为建筑、设计、展馆、广告、动漫、影视、文体娱乐活动等行业的客户提供涵盖CG静态、CG动态、CG视觉场景综合业务的数字视觉综合服务。',
              stockRightCode: '300556'
            },
            {
              imgUrl: investTMT2,
              name: '卫士通',
              introduce: '卫士通信息产业股份有限公司是国内知名密码产品、网络安全产品、互联网安全运营、行业安全解决方案综合提供商，首批商密产品研发、生产、销售资质单位，首批涉密信息系统集成甲级资质单位，国内专业从事网络信息安全的上市公司。',
              stockRightCode: '002268'
            },
            {
              imgUrl: investTMT3,
              name: '迅游科技',
              introduce: '迅游科技创建于2008年，中国领先的网络游戏加速服务商，其核心产品“迅游网游加速器”、“迅游国际版“、“迅游手游加速器”支持桌面及手机网络游戏超过13000款，注册用户过亿。',
              stockRightCode: '300467'
            },
            {
              imgUrl: investTMT4,
              name: '云端传媒',
              introduce: '北京云端文化传媒股份有限公司以IP的泛娱乐化运营为宗旨，立足于电影、电视剧、网络剧孵化、制作，同时覆盖影视剧发行、艺人经纪及泛娱乐衍生商务为一体的影视传媒公司。'
            },
            {
              imgUrl: investTMT5,
              name: '中联信通',
              introduce: '成都中联信通科技股份有限公司是一家专注于移动支付与金融科技、移动智能服务的高科技创新企业。参与国家移动支付标准的制定，首创了NFC手机与金融IC卡移动金融服务框架，作为成都移动金融试点单位参与规划和建设了四川省金融IC卡暨移动金融基础服务平台。'
            },
            {
              imgUrl: investTMT6,
              name: '瀚信科技',
              introduce: '广州瀚信通信科技股份有限公司是一家专注于移动通信技术服务和相关产品研发的移动通信网络综合解决方案提供商。'
            },
            {
              imgUrl: investTMT7,
              name: '基恒通信',
              introduce: '北京基恒通信是一家为用户提供通信设备综合服务的专业技术公司 ，也是唯一一家同时获得无线、有线和配套设备服务资质的民营企业。'
            },
            {
              imgUrl: investTMT8,
              name: '科旭网络',
              introduce: '上海科旭网络科技股份有限公司是一家以通信信息技术服务及相关软硬件产品为主营业务的高科技公司，是行业内最早提供通信网络技术服务整体解决方案的专业技术服务商。'
            }
          ]
        },
        {
          id: 4,
          slideInfo: [
            {
              imgUrl: investEnvir1,
              name: '超日太阳能',
              introduce: '上海超日太阳能科技股份有限公司是一家汇聚众多太阳能科技领域高级人才，研究、开发、利用太阳能资源的高科技民营企业。',
              stockRightCode: '002506'
            },
            {
              imgUrl: investEnvir2,
              name: '天顺风能',
              introduce: '天顺风能业务涵盖塔筒制造、叶片制造、零部件加工制造、风电场项目开发和运营、危废处理、新能源和清洁能源投资等多个领域的集团性公司。中国国内唯一一家同时获得Vestas、GE和Siemens全球风塔合格供应商资格认证的公司，生产规模和产品质量在行业内均位居前列。',
              stockRightCode: '002531'
            },
            {
              imgUrl: investEnvir3,
              name: '中国天楹',
              introduce: '中国天楹股份有限公司是一家环保新能源上市公司，主要业务包括投资、建设、运营、维护环保基础设施项目和环保设备的研发、生产、销售；业务范围覆盖生活垃圾焚烧发电及蒸汽生产、污泥处理、餐厨垃圾处理、危险废弃物处理、建筑垃圾处理、污水处理、填埋气开发与利用、垃圾分类收运体系投资与运营等领域。',
              stockRightCode: '000035'
            }
          ]
        }
      ]
    }
  },
  methods: {
    clickEvent: function (index) {
      this.isActive = index
    }
  }
}
</script>

 <style scoped>
.swiper-container{
    padding-bottom: 70px;
}
.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
    bottom: 0;
}
.swiper-slide {
    background: #fff;
    /* box-shadow: 0 0 16px 10px rgba(0, 0, 0, 0.03); */
    /* border: 1px solid #eee; */
    padding: 15px;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
 }
.swiper-slide img{
      width: 100%;
      box-shadow: 0 0 16px 10px rgba(0, 0, 0, 0.03);
  }
 .swiper .info{
     width: 100%;
     /*width: 399px;*/
     height: 100%;
     margin: 15px;
     position: absolute;
     top: 100%;
     left: 0;
     background: rgba(51, 51, 102, 0.9);
     -moz-background: rgba(51, 51, 102, 0.9);
     color: #fff;
     text-align: center;
     padding: 60px 24px;
     box-sizing: border-box;
     transition: all 0.6s;
    -moz-transition: all 0.6s;
 }
.swiper .info .name{
    font-size: 22px;
    margin-bottom: 22px;
}
.swiper .info .mt_60{
  margin-top: 20%;
}
.swiper .info .introduce{
    font-size: 14px;
    text-align: justify;
    line-height: 22px;
    margin-bottom: 30px;
}
.swiper .info .bold-font{
    font-size: 20px;
}
.swiper-slide:hover .info{
    top: 0;
}
.content4{
    min-width: 1200px;
    padding-top: 136px;
}
  .content4 .tab{
    padding: 0 120px 0px 174px;
    margin-bottom: 60px;
 }
 .content4 .title{
    font-size: 24px;
    color: #c70016;
    font-weight: 600;
 }
 .content4 .tab .title span{
     font-weight: 600;
    color: #333367;
 }
.content4 .tab ul{
    display: table;
    table-layout: fixed;
}
.content4 .tab li{
    display: table-cell;
    width: 100px;
    line-height: 42px;
    cursor: pointer;
    color: #1e1e1e;
    font-size: 18px;
    text-align: center;
    position: relative;
}
.content4 .tab .active{
    width: 32px;
    height: 4px;
    background: #c8001c;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-16px);
    -moz-transform: translateX(-16px);
}
 </style>



// WEBPACK FOOTER //
// src/components/investCase/investCase.vue